/** useIssuesWorkSelection — Auswahl-State der Arbeitsliste (P2a/B3-Zubringer). ≤50 Zeilen. */
import { useCallback, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import type { IssuesWorkRow } from './workTableAdapter'

const MAX_BULK = 50

export function useIssuesWorkSelection(rows: IssuesWorkRow[]) {
  const navigate = useNavigate()
  const [selectedIds, setSelectedIds] = useState<Set<string>>(new Set())

  const toggle = useCallback((id: string) => {
    setSelectedIds((prev) => {
      const next = new Set(prev)
      if (next.has(id)) next.delete(id)
      else next.add(id)
      return next
    })
  }, [])

  const toggleAll = useCallback((pageIds: string[]) => {
    setSelectedIds((prev) => {
      const allOnPage = pageIds.length > 0 && pageIds.every((id) => prev.has(id))
      const next = new Set(prev)
      if (allOnPage) pageIds.forEach((id) => next.delete(id))
      else pageIds.forEach((id) => next.add(id))
      return next
    })
  }, [])

  const clear = useCallback(() => setSelectedIds(new Set()), [])

  const ids = useMemo(() => [...selectedIds].slice(0, MAX_BULK), [selectedIds])

  const createTexts = useCallback(() => {
    navigate(`/v2/tools/text/bulk?products=${ids.join(',')}`)
  }, [navigate, ids])

  const createImages = useCallback(() => {
    const names = ids.map((id) => encodeURIComponent(rows.find((r) => r.id === id)?.name ?? ''))
    navigate(`/v2/tools/generate/batch?products=${ids.join(',')}&names=${names.join(',')}&mode=matrix`)
  }, [navigate, ids, rows])

  return { selectedIds, toggle, toggleAll, clear, createTexts, createImages }
}
